export default __webpack_public_path__ + "static/media/checked_green.620242b8.svg";